<script>
import mixin from '@/plans/mx/shopping-cart';
import { isZoomMeetingAsAddonCard } from '@/plans/ZOOM_MEETING/common/utils';

const categories = {
  basic: 'billing.planform.title.zoom_one',
  pro: 'billing.planform.title.zoom_one_pro',
  biz: 'billing.planform.title.zoom_one_biz',
};

export default {
  mixins: [mixin],
  methods: {
    renderTitle(plan) {
      if (this.$context.is.pro2biz) {
        return (
          <div>
            {this.mx_title(this.$t(categories['basic']))}
            {this.mx_subTitle(this.$t('billing.pro2biz.title'), this.mx_price(plan))}
          </div>
        );
      }
      return (
        <div>{this.mx_title(this.$t(categories[plan.category]), this.mx_price(plan))}</div>
      );
    },
    $renderPrice() {
      return this.mx_plans.map((plan) => {
        return (
          <div class="opc-cart-item">
            {this.renderTitle(plan)}
            {this.mx_discount(plan.plan_code)}
            {this.mx_license(plan.cartInfo.selected_number)}
            {this.mx_cycle(plan.billing_cycle)}
            {this.mx_edit(plan)}
            {!this.mx_isLastBasePlanForTheSameBillingCycle && (!this.mx_isLastBasePlan || isZoomMeetingAsAddonCard()) && this.mx_remove(plan)}
          </div>
        );
      });
    },
  },
};
</script>
